import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAInterview, getInterviews, resetState } from "../features/interview/interviewSlicee";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "title",
  },
  {
    title: "Category",
    dataIndex: "category",
  },
  {
    title: "Video ID",
    dataIndex: "videos",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Interviewlist = () => {
  const [open, setOpen] = useState(false);
  const [InterviewId, setInterviewId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setInterviewId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getInterviews());
  }, []);
  const getInterviewState = useSelector((state) => state.interview.Interviews);
  console.log(getInterviewState);
  const data1 = [];
  for (let i = 0; i < getInterviewState.length; i++) {
    data1.push({
      key: i + 1,
      title: getInterviewState[i].title,
      category:getInterviewState[i].category,
      videos:getInterviewState[i].videos,

      action: (
        <>
          <Link
            to={`/admin/Add-Interview/${getInterviewState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getInterviewState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAInterview(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getInterviews());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Interview List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(InterviewId);
        }}
        title="Are you sure you want to delete this Interview?"
      />
    </div>
  );
};

export default Interviewlist;
